(() => {
  const STORAGE_KEY = 'contact_form_klaviyo_payload';
  const SENT_EVENT_KEY = 'contact_form_klaviyo_last_sent_event_id';

  function normalizeContactFields(form) {
    const data = new FormData(form);
    const fields = {};

    for (const [rawKey, value] of data.entries()) {
      if (!rawKey.startsWith('contact[') || !rawKey.endsWith(']')) {
        continue;
      }

      const fieldName = rawKey.slice('contact['.length, -1);

      if (fields[fieldName] === undefined) {
        fields[fieldName] = value;
        continue;
      }

      if (Array.isArray(fields[fieldName])) {
        fields[fieldName].push(value);
      } else {
        fields[fieldName] = [fields[fieldName], value];
      }
    }

    return fields;
  }

  function savePayload(form) {
    try {
      const contactFields = normalizeContactFields(form);
      const email =
        contactFields.email ||
        contactFields['Email'] ||
        contactFields['E-mail'] ||
        contactFields['e-mail'] ||
        null;

      const name =
        contactFields['Name'] ||
        contactFields['Full name'] ||
        contactFields['Full Name'] ||
        contactFields['contact.form.name'] ||
        null;

      const messageKey = Object.keys(contactFields).find((key) =>
        key.toLowerCase().includes('message')
      );
      let message = messageKey ? contactFields[messageKey] : null;

      if (typeof message === 'string' && message.length > 5000) {
        message = message.slice(0, 5000);
      }

      const payload = {
        email,
        name,
        message,
        contactFields,
        pageUrl: window.location.href,
        locale:
          (window.Shopify && window.Shopify.locale) ||
          document.documentElement.lang ||
          null,
        submittedAt: Date.now(),
        formId: form.getAttribute('id') || null,
      };
      payload.eventId = `${payload.formId || 'contact-form'}:${payload.submittedAt}`;

      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      console.error('Contact Klaviyo: failed to save payload', e);
    }
  }

  function loadPayload() {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (_e) {
      return null;
    }
  }

  function clearPayload() {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }

  function isAlreadySent(eventId) {
    if (!eventId) return false;
    return window.sessionStorage.getItem(SENT_EVENT_KEY) === eventId;
  }

  function markAsSent(eventId) {
    if (!eventId) return;
    window.sessionStorage.setItem(SENT_EVENT_KEY, eventId);
  }

  function sendToKlaviyo(payload) {
    if (!window._learnq || typeof window._learnq.push !== 'function') {
      return false;
    }

    try {
      const eventProps = {
        eventId: payload.eventId,
        contactFields: payload.contactFields,
        pageUrl: payload.pageUrl,
        locale: payload.locale,
        formId: payload.formId,
        submittedAt: new Date(payload.submittedAt).toISOString(),
      };

      if (payload.message) {
        eventProps.message = payload.message;
      }

      window._learnq.push([
        'track',
        'Submitted Contact Form',
        eventProps,
      ]);
      return true;
    } catch (e) {
      console.error('Contact Klaviyo: failed to send to Klaviyo', e);
      return false;
    }
  }

  function bindFormCapture() {
    const forms = document.querySelectorAll(
      'form[data-contact-klaviyo="true"]'
    );
    if (!forms.length) return;

    forms.forEach((form) => {
      if (form.__contactKlaviyoBound) return;
      form.__contactKlaviyoBound = true;

      form.addEventListener(
        'submit',
        () => {
          savePayload(form);
        },
        { capture: true }
      );
    });
  }

  function handleSuccessAndSync() {
    const payload = loadPayload();
    if (!payload) return;

    const hasSuccessAlert = !!document.querySelector(
      '[data-contact-success="true"]'
    );

    if (!hasSuccessAlert) return;
    if (isAlreadySent(payload.eventId)) {
      clearPayload();
      return;
    }

    let attempts = 0;
    const maxAttempts = 20;
    const timer = window.setInterval(() => {
      attempts += 1;
      const sent = sendToKlaviyo(payload);
      if (sent) {
        markAsSent(payload.eventId);
        clearPayload();
        window.clearInterval(timer);
      } else if (attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  function onReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  onReady(() => {
    bindFormCapture();
    handleSuccessAndSync();
  });
})();

